import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
  LINKTREES_FETCH,
  LINKTREE_FETCH,
  LINKTREE_INSERT,
  LINKTREE_UPDATE,
  LINKTREE_DELETE,
  LINKTREES_ORDERBY,
  LINKTREES_FILTER,
  LINKTREES_PAGINATION,
  LINKTREE_LINKS_FETCH,
  LINKTREE_LINK_INSERT,
  LINKTREE_LINK_UPDATE,
  LINKTREE_LINK_DELETE,
} from "../constants";

const initialState = {
  linktrees: [],
  linktreesCount: 0,
  linktree: null,
  linktreeLinks: [],
  linktreesOrderBy: "createdAt",
  linktreesFilter: null,
  linktreesPagination: {
    defaultActivePage: 1,
    totalPages: 1,
    activePage: 1,
  },
};

const persistConfig = {
  key: "linktree",
  storage,
  blacklist: [
    "linktreesPagination",
    "linktreesFilter",
  ],
};

function linktreeReducer(state = initialState, action) {
  switch (action.type) {
    case LINKTREES_FETCH:
      return { ...state, linktrees: action.result, linktreesCount: action.count };

    case LINKTREE_FETCH:
      return { ...state, linktree: action.result };

    case LINKTREE_INSERT:
      return {
        ...state,
        linktrees: [action.result, ...state.linktrees],
        linktreesCount: state.linktreesCount + 1,
      };

    case LINKTREE_UPDATE:
      return {
        ...state,
        linktrees: state.linktrees.map(lt =>
          lt.id === action.result.id ? action.result : lt
        ),
      };

    case LINKTREE_DELETE:
      return {
        ...state,
        linktrees: state.linktrees.filter(lt => lt.id !== action.id),
        linktreesCount: state.linktreesCount - 1,
      };

    case LINKTREE_LINKS_FETCH:
      return { ...state, linktreeLinks: action.result };

    case LINKTREE_LINK_INSERT:
      return { ...state, linktreeLinks: [action.result, ...state.linktreeLinks] };

    case LINKTREE_LINK_UPDATE:
      return {
        ...state,
        linktreeLinks: state.linktreeLinks.map(l =>
          l.id === action.result.id ? action.result : l
        ),
      };

    case LINKTREE_LINK_DELETE:
      return {
        ...state,
        linktreeLinks: state.linktreeLinks.filter(l => l.id !== action.id),
      };

    case LINKTREES_ORDERBY:
      return { ...state, linktreesOrderBy: action.value };

    case LINKTREES_FILTER:
      return { ...state, linktreesFilter: action.value };

    case LINKTREES_PAGINATION:
      return { ...state, linktreesPagination: action.value };

    default:
      return state;
  }
}

export default persistReducer(persistConfig, linktreeReducer);